import script from "./InspectorEnvironment.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorEnvironment.vue?vue&type=script&setup=true&lang=js"

import "./InspectorEnvironment.vue?vue&type=style&index=0&id=06ed7cba&lang=scss&scoped=true"
import "./InspectorEnvironment.vue?vue&type=style&index=1&id=06ed7cba&lang=css"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ed7cba"]])

export default __exports__